import script from "./configPage.vue?vue&type=script&setup=true&lang=js"
export * from "./configPage.vue?vue&type=script&setup=true&lang=js"

import "./configPage.vue?vue&type=style&index=0&id=4781629c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4781629c"]])

export default __exports__